import { createFeatureSelector } from '@ngrx/store';

export const crmDropdownsFeatureSelector = createFeatureSelector<any>('crmDropdowns');
